// removed by extract-text-webpack-plugin
module.exports = {"RightMenu":"RightMenu__RightMenu___3YHOj","Client":"RightMenu__Client___AaNpd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Chess/RightMenu/RightMenu.scss
// module id = 1345
// module chunks = 0